import { useState } from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import { About, WhyChoose, HowItWorks } from "../components/landing/AboutBenefitsSteps";
import { Coach, Testimonials } from "../components/landing/CoachTestimonials";
import { Pricing, PersonalTraining } from "../components/landing/Pricing";
import { FAQ, FinalCTA, Footer, WhatsAppFloat } from "../components/landing/FAQContact";
import ConsultationDialog from "../components/landing/ConsultationDialog";

export default function Landing() {
  const [open, setOpen] = useState(false);
  const openBooking = () => setOpen(true);

  return (
    <div className="min-h-screen bg-brand-bg text-brand-ink font-sans" data-testid="landing-page">
      <Header onBookClick={openBooking} />
      <main>
        <Hero onBookClick={openBooking} />
        <About />
        <WhyChoose />
        <HowItWorks />
        <Coach onBookClick={openBooking} />
        <Testimonials />
        <Pricing onBookClick={openBooking} />
        <PersonalTraining />
        <FAQ />
        <FinalCTA onBookClick={openBooking} />
      </main>
      <Footer />
      <WhatsAppFloat />
      <ConsultationDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
